import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('registerReportingPointStore', Object.keys(state)),
	...mapGetters('registerReportingPointStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('registerReportingPointStore', Object.keys(actions)),
	...mapMutations('registerReportingPointStore', Object.keys(mutations))
};
